import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RxDotFilled } from "react-icons/rx";
import { useMediaQuery } from "react-responsive";
import {
  hero1,
  hero2,
  hero3,
  hero4,
  hero5,
  hero6,
  hero7,
  hero8,
} from "../../images";

const Hero: React.FC = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery({ maxWidth: 767 });
  const isLargeScreen = useMediaQuery({ minWidth: 768 });

  // Define slides based on screen size with added text color property
  const slides = isSmallScreen
    ? [
        {
          url: hero4,
          title: "Hero 4",
          textColor: "text-white", // Set appropriate color for each slide
          subTextColor: "text-gray-300",
        },
        {
          url: hero5,
          title: "Hero 5",
          textColor: "text-yellow-100",
          subTextColor: "text-yellow-200",
        },
        {
          url: hero6,
          title: "Hero 6",
          textColor: "text-blue-100",
          subTextColor: "text-blue-200",
        },
        {
          url: hero7,
          title: "Hero 7",
          textColor: "text-green-100",
          subTextColor: "text-green-200",
        },
      ]
    : isLargeScreen
    ? [
        {
          url: hero4,
          title: "Hero 4",
          textColor: "text-white",
          subTextColor: "text-gray-300",
        },
        {
          url: hero5,
          title: "Hero 5",
          textColor: "text-yellow-100",
          subTextColor: "text-yellow-200",
        },
        {
          url: hero6,
          title: "Hero 6",
          textColor: "text-blue-100",
          subTextColor: "text-blue-200",
        },
        {
          url: hero7,
          title: "Hero 7",
          textColor: "text-green-100",
          subTextColor: "text-green-200",
        },
        {
          url: hero8,
          title: "Hero 8",
          textColor: "text-purple-100",
          subTextColor: "text-purple-200",
        },
      ]
    : [];

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex);
  };

  const handleGetStarted = () => {
    navigate("/courses");
  };

  // Auto slide every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div className="w-full relative h-[65vh] lg:h-[80vh] overflow-hidden">
      {/* Carousel Slides */}
      {slides.map((slide, slideIndex) => (
        <div
          key={slideIndex}
          className={`absolute inset-0 w-full h-full transition-opacity duration-500 ${
            currentIndex === slideIndex
              ? "opacity-100"
              : "opacity-0 pointer-events-none"
          }`}>
          <img
            loading="lazy"
            src={slide.url}
            alt={slide.title}
            className="object-cover w-full h-full"
          />
        </div>
      ))}

      {/* Content Overlay */}
      <div className="absolute inset-0 flex items-center justify-center px-5 md:px-20">
        <div className="flex relative flex-col items-center max-w-full w-[595px] text-center">
          <h1
            className={`text-4xl md:text-6xl font-semibold transition-colors duration-500 ${slides[currentIndex]?.textColor}`}>
            Welcome to the <br /> Future of Learning
          </h1>
          <p
            className={`mt-4 text-base tracking-wide leading-5 font-medium transition-colors duration-500 ${slides[currentIndex]?.subTextColor}`}>
            Bring Your Class Experience Online <br />
            With Our Cutting-edge Solutions.
          </p>
          <div className="flex gap-4 mt-9">
            <button
              onClick={handleGetStarted}
              className="px-6 py-2 rounded-full hover:bg-orange-600 transition-colors duration-300 text-lg text-white bg-orange-500 w-fit transform hover:scale-105">
              Get Started
            </button>
          </div>
        </div>
      </div>

      {/* Dots Navigation */}
      <div className="flex absolute bottom-8 justify-center w-full">
        {slides.map((slide, slideIndex) => (
          <div
            key={slideIndex}
            className={`text-2xl cursor-pointer mx-1 ${
              currentIndex === slideIndex ? "text-white" : "text-gray-500"
            }`}
            onClick={() => goToSlide(slideIndex)}>
            <RxDotFilled />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
